import React, { useState, useEffect } from "react";
import { Container } from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { DataGrid } from "@mui/x-data-grid";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { Action, DefaultPerPageValue, PerPage, ProjectTag } from "../../constants/Common";
import Loader from "../../Components/Common/Loader";
import NodataFound from "../../Components/Common/NoDataFound";
import userImage from "../../assets/images/icons/ticket.png";
import { Helmet } from "react-helmet";
import { filter } from "lodash/collection";
import Tooltip from '@mui/material/Tooltip';
import { get } from "lodash/object";
import { getIconPath } from "../../helpers/file_helper";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import { hasModulePermission } from "../../helpers/permission";
import { Modules } from "../../constants/Module";
import { deleteProject, getAllProject, sendMessageToAssignedUser, updateProjectTagStatus } from "../../api/casp/project";
import EditIcon from "../../assets/images/icons/edit-line.svg";
import { ProjectStatusColor } from "../../constants/StatusColor";
import { Role } from "../../constants/Role";
import { useSelector } from "react-redux";
import { Autocomplete, Button, TextField } from "@mui/material";
import { toast } from "react-toastify";
import { useNavigate, useLocation } from "react-router-dom";
import { withTranslation } from "react-i18next";
import Search from "../../Components/casp/common/Search";
import { ProjectStatuses } from "../../constants/Status";
import PauseCircleFilledIcon from '@mui/icons-material/PauseCircleFilled';
import PlayCircleFilledWhiteIcon from '@mui/icons-material/PlayCircleFilledWhite';
import StopIcon from '@mui/icons-material/Stop';
import SweetAlert from "react-bootstrap-sweetalert";
import ReasonModal from "../../Components/casp/common/ReasonModal";
import AddMessageModal from "../../Components/casp/common/AddMessageModal";
import AddProjectDrawer from "../../Components/casp/project/AddProjectDrawer";
import CsvUpload from "../../common/CsvUpload";
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import DeleteIcon from '../../assets/images/icons/Delete.svg'
import { getAllPortfolios } from "../../api/casp/portfolio";
import SearchDropDownListPaginationComponent from "../../Components/casp/common/SearchDropDownPaginationList";

const ProjectList = (props) => {
  const [projectList, setProjectList] = useState([]);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(DefaultPerPageValue);
  const [rowCount, setRowCount] = useState(0);
  // const [projectFilter, setProjectFilter] = useState();
  const [projectFilter, setProjectFilter] = useState({ filterFields: [], filterInputs: [] });
  const [triggerData, setTriggerData] = useState(+new Date());
  const [isLoading, setIsLoading] = useState(false);
  const [selectedProjectRow, setSelectedProjectRow] = useState();
  const [status, setStatus] = useState();
  const [action, setAction] = useState();
  const [isReasonModal, setIsReasonModal] = useState()
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [projectCreationLoading, setProjectCreationLoading] = useState(false);
  const hasEditPermissionForProjectList = hasModulePermission(Modules.USER, Action.EDIT)
  const hasViewPermissionForProjectList = hasModulePermission(Modules.USER, Action.VIEW)
  const hasCreatePermissionForProject = hasModulePermission(Modules.USER, Action.CREATE)
  const hasDeletePermissionForProject = hasModulePermission(Modules.USER, Action.DELETE)
  const loggedInUser = useSelector((state) => state.Profile.user);
  const [refreshKey, setRefreshKey] = useState(0);
  const [selectedProject, setSelectedProject] = useState();
  const [openSweetAlert, setOpenSweetAlert] = useState(false);

  const [isOpenSweetAlert, setIsOpenSweetAlert] = useState({
    status: false,
    data: null
  })
  const [rightDrawer, setRightDrawer] = useState({
    right: false
  });
  const [isSendMsg, setIsSendMsg] = useState({
    status: false,
    data: []
  })
  const location = useLocation()
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [portfolio,setPortfolio] = useState()

  const openCsvModal = () => {
    setPopupOpen(true);

  };

  const handlePopupClose = () => {
    setPopupOpen(false);
  }

  useEffect(() => {
    const filter = location?.state?.filterData ? JSON.parse(location.state?.filterData) : {}
    setProjectFilter(filter);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location?.state?.filterData]);

  useEffect(() => {
  fetchProjectList({
    page: page + 1,
    perPage: rowsPerPage,
    ...projectFilter,
  });
// eslint-disable-next-line react-hooks/exhaustive-deps
}, [triggerData, projectFilter, page, rowsPerPage]);


  const columns = [
    // {
    //   field: "index",
    //   headerName: "#",
    //   width: 85,
    //   filterable: false,
    //   sortable: false,
    //   renderCell: (params) => (
    //     <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
    //       <div className="MuiDataGrid-cellContent">{params.row?.indexNo}</div>
    //     </div>
    //   ),
    // },
    // {
    //   field: "uniqueProjectId",
    //   headerName: props.t("Startup ID"),
    //   width: 250,
    //   filterable: false,
    //   sortable: false,
    //   renderCell: (params) => (
    //     <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
    //       <div className="MuiDataGrid-cellContent">
    //         {params.row?.uniqueProjectId}
    //       </div>
    //     </div>
    //   ),
    // },
    {
      field: "projectName",
      headerName: props.t("Startup Name"),
      flex: 1.5,
      filterable: false,
      sortable: false,
      renderCell: (params) =>
        loggedInUser?.role?.name === Role.MENTOR ? (
          <span
            style={{ color: "#007bff", cursor: "pointer", textDecoration: "underline" }}
            onClick={() => navigate(`/project/${params.row.id}/details`)}
          >
            {params.row.projectName}
          </span>
        ) : (
          <span>{params.row.projectName}</span>
        ),
    },
    {
      field: "status",
      headerName: props.t("Status"),
      flex: 1,
      filterable: false,
      sortable: false,
      renderCell: (params) => (
        <div
          className={`statusBadge ${ProjectStatusColor(
            params.row?.status
          )} badge-outlined text-center text-capitalize`}
        >
          {props.t(params.row?.status)}
        </div>
      ),
    },
    {
      field: "tag",
      headerName: props.t("Startup Tag"),
      flex: 1,
      filterable: false,
      sortable: false,
      renderCell: (params) => (
        <div>
          {params.row.tag !== ProjectTag.ACTIVE ? (
            <Tooltip title={`Reason: ${params.row?.reason}`}>
              <span
                className={`statusBadge ${ProjectStatusColor(
                  params.row?.tag
                )} badge-outlined text-center text-capitalize`}
              >
                {props.t(params.row?.tag)}
              </span>
            </Tooltip>
          ) : (
            <span
              className={`statusBadge ${ProjectStatusColor(
                params.row?.tag
              )} badge-outlined text-center text-capitalize`}
            >
              {props.t(params.row?.tag)}
            </span>
          )}
        </div>
      ),
    },
  ];

  const [columnData, setColumnData] = useState([...columns])

  useEffect(() => {
    if (hasEditPermissionForProjectList || hasViewPermissionForProjectList || hasDeletePermissionForProject) {
      setColumnData((prev) =>
        [
          ...columns,
          {
            field: "actions",
            headerName: props.t("Actions"),
            flex: 1.2,
            minWidth: 130,
            sortable: false,
            filterable: false,
            hideable: false,
            renderCell: (params) => (
              (
                <div style={{ display: "flex", alignItems: "center", justifyContent: 'space-between' }}>
                  <div className="newActionIcons">
                    {hasEditPermissionForProjectList && params.row.status === ProjectStatuses.ONGOING && (
                      <>
                        {params.row?.tag === ProjectTag.ACTIVE && (
                          <Tooltip title={props.t("Deactive Startup")}>
                            <PauseCircleFilledIcon
                              style={{ cursor: "pointer", fill: '#6B7083' }}
                              onClick={() => {
                                setIsOpenSweetAlert({
                                  status: false,
                                  data: { tag: ProjectTag.INACTIVE, id: params.row.id }
                                })
                                setIsReasonModal(true)
                              }} />
                          </Tooltip>
                        )}
                        {params.row?.tag === ProjectTag.INACTIVE && (
                          <Tooltip title={props.t("Active Startup")}>
                            <PlayCircleFilledWhiteIcon
                              style={{ cursor: "pointer", fill: '#6B7083' }}
                              onClick={() => {
                                setIsOpenSweetAlert({
                                  status: true,
                                  data: { tag: ProjectTag.ACTIVE, id: params.row.id }
                                })
                              }} />
                          </Tooltip>
                        )}

                        {params?.row?.tag !== ProjectTag.STOP && (
                          <Tooltip title={props.t("Stop Startup")}>
                            <StopIcon style={{ cursor: "pointer", fill: '#6B7083' }}
                              onClick={() => {
                                // setIsReasonModal(true)
                                setIsOpenSweetAlert({
                                  status: false,
                                  data: { tag: ProjectTag.STOP, id: params.row.id }
                                })
                                setIsReasonModal(true)
                              }} />
                          </Tooltip>
                        )}
                      </>
                    )}
                    {hasViewPermissionForProjectList &&
                      <Tooltip title={props.t("View Startup")}>
                        <RemoveRedEyeOutlinedIcon
                          style={{ cursor: "pointer", fill: '#6B7083' }}
                          onClick={() => navigate(`/project/${params.row.id}/details`)}
                        />
                      </Tooltip>
                    }
                    {hasEditPermissionForProjectList && params?.row?.tag === ProjectTag.ACTIVE &&
                      <Tooltip title={props.t("Edit Startup")}>
                        <EditOutlinedIcon style={{ fill: '#6B7083' }} onClick={toggleDrawer("right", true, params.row, Action.EDIT)}>
                          <img src={EditIcon} alt={EditIcon} />
                        </EditOutlinedIcon>
                      </Tooltip>
                    }
                    {hasDeletePermissionForProject && params?.row?.status === ProjectStatuses.DRAFT &&
                      <Tooltip title={props.t("Delete Startup")}>
                        <DeleteOutlineOutlinedIcon
                          style={{ fill: '#6B7083' }}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleClickDelete(params.row, Action.DELETE);
                          }}
                        >
                          <img src={DeleteIcon} alt={DeleteIcon} />
                        </DeleteOutlineOutlinedIcon>
                      </Tooltip>
                    }
                  </div>
                </div>
              )
            ),
          },
        ]
      )
    }

    if (!hasEditPermissionForProjectList && !hasViewPermissionForProjectList && !hasDeletePermissionForProject) {
      setColumnData([...columns])
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasEditPermissionForProjectList, hasViewPermissionForProjectList, hasDeletePermissionForProject, localStorage.getItem("I18N_LANGUAGE")])

  const fetchProjectList = async (queryParams) => {
    try {
      setIsLoading(true);
      let params = {
        ...queryParams,
        ...(search && { search }),
        // perPage: rowsPerPage,
        // page: page + 1,
      }
      const res = (await getAllProject(params)).data.data;
      let level = (params?.page + 1 - 1) * params?.perPage;
      const resultData = res.data.map((res) => {
        return {
          id: res.id,
          indexNo: ++level,
          uniqueProjectId: res.uniqueProjectId,
          projectName: res.name,
          status: res.status,
          tag: res.tag,
          reason: res.reason
        };
      });
      setProjectList(resultData);
      setRowCount(res.meta.total);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }

  const handleUpdateProjectStatus = async () => {
    try {
      setProjectCreationLoading(true);
      const payload = {
        tag: isOpenSweetAlert?.data?.tag,
        ...(isOpenSweetAlert?.data?.tag !== ProjectTag.ACTIVE && { reason: isOpenSweetAlert.data.reason })
      }
      const response = await updateProjectTagStatus(payload, isOpenSweetAlert.data?.id);
      if (response.statusCode === 200) {
        toast.success(response.data.message);
        setProjectList([]);
        page > 0
          ? setPage(0)
          : await fetchProjectList({ page: 1, perPage: rowsPerPage });
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setProjectCreationLoading(false);
      setIsReasonModal(false)
      setIsOpenSweetAlert({
        status: false,
        data: null
      })
    }
  };

  const handleTypeChange = (_, item) => {
    setProjectFilter(prev => {
      const newFields = [...(prev.filterFields || [])];
      
      const newInputs = [...(prev.filterInputs || [])];

      const index = newFields.indexOf("status");

      if (index !== -1) {
        newFields.splice(index, 1);
        newInputs.splice(index, 1);
      }

      if (item != null) {
        newFields.push("status");
        newInputs.push(item);
      }

      return { filterFields: newFields, filterInputs: newInputs };
    });
    
    setPage(0)

    setTriggerData(+new Date());
  };


  const toggleDrawer = (anchor, open, params, action) => (event, reason) => {
    if (reason === "backdropClick") {
      return;
    }
    if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setRightDrawer({ ...rightDrawer, [anchor]: open });
    setIsDrawerOpen(true)
    setSelectedProjectRow(params);
    setAction(action);
  };

  const handleClickDelete = (params, action) => {
    if (action === Action.DELETE) {
      setSelectedProject(params);
      setOpenSweetAlert(true);
    }
  }

  const deleteStartup = async () => {
    try {
      const res = await deleteProject(selectedProject.id)
      if (res.statusCode === 200) {
        toast.success(res.data.message)
        // Refresh current page
        setTriggerData(+new Date())
      }
    } catch (err) {
      toast.error(err.message)
    }
    finally {
      setOpenSweetAlert(false)
    }
  }

  /** Fetch user list from api */
  //   const fetchUserList = async (searchItem = "") => {
  //     try {
  //       setIsLoading(true);
  //       let params = {
  //         page: page + 1,
  //         perPage: rowsPerPage,
  //         ...(searchItem && {
  //           ...searchItem,
  //         }),
  //         includeAdmins: false,
  //       };

  //       const res = (await getUserList(params)).data.data;
  //       let level = (page + 1 - 1) * rowsPerPage;
  //       const resultData = res.data.map((res) => {
  //         return {
  //           id: res.id,
  //           indexNo: ++level,
  //           uniqueUserId: res.uniqueUserId,
  //           firstName: res.firstName,
  //           lastName: res.lastName,
  //           email: res.email,
  //           contactNo: res.contactNo,
  //           address: res.address,
  //           department: res.department,
  //           addressId: res.addressId,
  //           isActive: res.isActive,
  //           companyId: res.company.id
  //         };
  //       });
  //       setUserList(resultData);
  //       setRowCount(res.meta.total);
  //       setIsLoading(false);
  //     } catch (error) {
  //       setIsLoading(false);
  //     }
  //   };

  // Global Search
  const globalSearch = async (params) => {
    setSearch(params.search);
    const filter = location?.state?.filterData ? JSON.parse(location.state?.filterData) : {}
    await fetchProjectList({ ...params, ...filter });
  };

  const paginationModelMethod = async (data) => {
    setPage(data.page);
    setRowsPerPage(data.pageSize);
    setTriggerData(+new Date());
  };

  const getRowId = (row) => row.id;

  const sendMessageToAssignedUserForSelectedProject = async (message) => {
    try {
      const payload = {
        projectIds: isSendMsg?.data,
        message: message
      }
      const response = await sendMessageToAssignedUser(payload)
      if (response.statusCode === 200) {
        toast.success(response.data.message);
        setRefreshKey(refreshKey + 1)
        setIsSendMsg({ status: false, data: [] })
      } else {
        toast.error(response.data.message);
      }
    } catch (err) {
      toast.error(err.message)
    }
  }

  const handleCloseDrawer = async (message) => {
    setIsDrawerOpen(false);
    if (message === "success") {
      setProjectList([]);
      page > 0
        ? setPage(0)
        : await fetchProjectList({ page: 1, perPage: rowsPerPage });
    }

    setSelectedProjectRow();
    setAction();
    setRightDrawer({ right: false });
  };

  return (
    <React.Fragment>
      <div className="page-content position-relative">
        <Helmet
          onChangeClientState={(newState, addedTags) => {
            try {
              // Check if we added any new link[rel="icon"] elements.
              const newFaviconElems = filter(get(newState, "linkTags", []), {
                rel: "icon",
              });

              if (!newFaviconElems.length) {
                return;
              }

              // Get the href of the last link element we just added, which
              // we assume is the most recently-added favicon.
              const newFaviconHref =
                newFaviconElems[newFaviconElems.length - 1].href;

              // Remove all react-helmet link elements with rel="icon" that
              // do not have the href of our recently-added favicon.
              // If no other favicon elements exist, we don't have to do
              // anything.
              const existingFavicons = document.querySelectorAll(
                `link[rel="icon"][data-react-helmet]:not([href="${newFaviconHref}"])`
              );

              if (existingFavicons.length) {
                existingFavicons.forEach((e) => e.parentNode.removeChild(e));
              }

              // Remove and re-add the latest link element to make sure
              // the browser uses it.
              const newFaviconElem = document.querySelector(
                `link[rel="icon"][data-react-helmet][href="${newFaviconHref}"]`
              );
              const iconToShow = <ManageAccountsIcon />;
              //<i className={'ri-git-pull-request-line'}></i>

              if (newFaviconElem) {
                const newFavElement = newFaviconElem.cloneNode(true);
                newFavElement.href = `data:image/svg+xml,${encodeURIComponent(
                  `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>${getIconPath(
                    iconToShow
                  )}</svg>`
                )}`;
                const parentElem = newFaviconElem.parentNode;
                parentElem.removeChild(newFaviconElem);
                parentElem.appendChild(newFavElement);
              }
            } catch (e) {
              console.error(e);
            }
          }}
        >
          <title>{props.t("Startup List")}</title>
        </Helmet>
        <Container fluid>
          <div className="d-flex justify-content-between align-items-center ongoingProjectsPg" style={{whiteSpace:"nowrap"}}>
            <div className="mainPageHeader d-flex justify-content-between me-1">
              <BreadCrumb title={props.t("Startup List")} />
            </div>
            <div className="d-flex justify-content-end ongoingSearchField">
              {!location?.state?.filterData && (
                <div className="me-2">
                  <Autocomplete
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={status}
                    size="small"
                    sx={{ width: "150px" }}
                    options={Object.values(ProjectStatuses)}
                    getOptionLabel={(option) => option ? props.t(option) : ""}
                    onChange={handleTypeChange}
                    renderInput={(params) => <TextField {...params}
                      label={props.t("Status")}
                    />}
                  />
                </div>
              )}
              <div className="me-2">
                <SearchDropDownListPaginationComponent
                  label={props.t("Cohort")}
                  sx={{
                  width: 170,
                  }}
                  disabled={projectCreationLoading}
                  searchEnabled={false}
                  listCall={getAllPortfolios}
                  disableClearable={!portfolio}
                  defaultValue={portfolio}
                  apiParams={{
                      order: "updatedAt",
                      direction: "desc",
                      ...(![
                          Role.PROJECT_MANAGER,
                          Role.EPMO_MANAGER,
                          Role.ROOT_ADMIN,
                          Role.VICE_PRESIDENT,
                          Role.PRESIDENT,
                          Role.PROGRAM_MANAGER,
                          Role.EPMO_OFFICER,
                          Role.MENTOR
                      ].includes(loggedInUser?.role?.name) && {
                          filterFields: "portfolioUser",
                          filterInputs: loggedInUser.id,
                      }),
                  }}
                  emitItem={(newValue) => {
                    setPortfolio(newValue);
                    setProjectFilter(prev => {
                      const newFields = [...prev.filterFields];
                      const newInputs = [...prev.filterInputs];

                      const index = newFields.indexOf("portfolioId");

                      if (index !== -1) {
                        newFields.splice(index, 1);
                        newInputs.splice(index, 1);
                      }

                      if (newValue) {
                        newFields.push("portfolioId");
                        newInputs.push(newValue.id);
                      }

                      return { filterFields: newFields, filterInputs: newInputs };
                    });

                    setPage(0)

                    setTriggerData(+new Date());
                  }}

                />
              </div>

              <div className="position-relative">
                <Search
                  listCall={globalSearch}
                  params={{
                    ...(props?.status ? {
                      filterFields: ["status"],
                      filterInputs: [props.status]
                    } : {}),
                    page: 1,
                    perPage: rowsPerPage,
                  }}
                />
                {/* <SearchOutlinedIcon /> */}
              </div>
              <div className="ms-2">
                {loggedInUser?.role?.name === Role.EPMO_OFFICER && hasCreatePermissionForProject && (
                  <Button
                    onClick={toggleDrawer("right", true)}
                    className="w-100 main-login-btn btn btn-secondary d-flex align-items-center px-1"
                    style={{fontSize:"10px"}}
                  >
                    <i className="las la-plus d-inline-block me-1"></i> {props.t("New Startup")}
                  </Button>
                )}
              </div>
              <div className="ms-2">
                {loggedInUser?.role?.name === Role.EPMO_OFFICER && hasCreatePermissionForProject && (
                  <Button
                    className="w-90 main-login-btn btn btn-secondary d-flex align-items-center px-1"
                    onClick={openCsvModal}
                    style={{fontSize:"10px"}}
                  >
                    <p className="mb-0">{props.t("Upload CSV")}</p>
                  </Button>
                )}
              </div>
              <div className="ms-2">
                {loggedInUser?.role?.name === Role.EPMO_OFFICER && (
                  <><Button
                    onClick={() => {
                      if (isSendMsg?.data?.length === 0) {
                        toast.error(props.t('Please select at least one startup'));
                      } else {
                        setIsSendMsg({ data: isSendMsg?.data, status: true });
                      }
                    }}
                    className="w-90 main-login-btn btn btn-secondary d-flex align-items-center px-1" style={{fontSize:"10px !important"}}
                  >
                    <i className="las la-plus d-inline-block me-1"></i>{props.t("Send Message")}
                  </Button>
                  </>
                )}
              </div>
            </div>
          </div>
          <div className="accordionTable my-4" style={{ width: "100%" }}>
            {projectList.length > 0 && (
              <DataGrid
                key={refreshKey}
                rows={projectList}
                columns={columnData}
                disableRowSelectionOnClick
                initialState={{
                  pagination: {
                    paginationModel: { pageSize: rowsPerPage },
                  },
                }}
                paginationMode="server"
                onPaginationModelChange={paginationModelMethod}
                rowCount={rowCount}
                pageSizeOptions={PerPage}
                getRowId={getRowId}
                loading={isLoading}
                onRowSelectionModelChange={(e) => setIsSendMsg({ data: e, status: false })}
                checkboxSelection={loggedInUser?.role?.name === Role.EPMO_OFFICER}
                localeText={{
                  MuiTablePagination: {
                    labelRowsPerPage: props.t("Startups per page:"),
                  },
                }}
              />
            )}
            {projectList.length === 0 && isLoading && <Loader />}
            {projectList.length === 0 && !isLoading && (
              <NodataFound text={props.t("No startup to show")} icon={userImage} />
            )}
          </div>
        </Container>
      </div>

      {isDrawerOpen && (
        <AddProjectDrawer
          isOpen={isDrawerOpen}
          handleClose={handleCloseDrawer}
          action={action}
          selectedProjectRow={selectedProjectRow}
        />
      )}

      {isOpenSweetAlert?.status && (
        <SweetAlert
          title={props.t(`Are you sure to ${isOpenSweetAlert.data.tag === ProjectTag.STOP ? 'stop' : isOpenSweetAlert.data.tag?.toLowerCase()} the startup?`)}
          warning
          showCancel
          confirmBtnText={props.t("OK")}
          cancelBtnText={props.t("Cancel")}
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          onConfirm={async () => {
            await handleUpdateProjectStatus();
          }}
          onCancel={() => {
            setIsOpenSweetAlert({
              status: false,
              data: null
            });
          }}
        > {isOpenSweetAlert.data.tag === ProjectTag?.STOP ? <b>{props.t('Once the startup is stopped, it cannot be activated again')}</b> : (
          isOpenSweetAlert.data.tag === ProjectTag?.INACTIVE ? <b>{props.t('Once the startup is deactivated, it can be activated again')}</b> : ''
        )}</SweetAlert>)}

      {isReasonModal && (
        <ReasonModal
          open={isReasonModal}
          module={Modules.PROJECT}
          action={isOpenSweetAlert.data.tag}
          handleClsoe={() => setIsReasonModal(false)}
          handleSave={(reason) => {
            setIsReasonModal(false)
            setIsOpenSweetAlert({ status: true, data: { ...isOpenSweetAlert.data, reason: reason } })
          }}
        />
      )}

      {isPopupOpen &&
        <CsvUpload
          createAssetsPermission="true"
          viewAssetsPermission="true"
          updateAssetsPermission="true"
          open={isPopupOpen}
          refresh={async () => await fetchProjectList()}
          onClose={handlePopupClose}
          module={Modules.PROJECT}
        />
      }

      {openSweetAlert && (
        <SweetAlert
          title={props.t("Are you sure want to delete this startup") + "?"}
          warning
          showCancel
          confirmBtnText={props.t("OK")}
          cancelBtnText={props.t("Cancel")}
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          onConfirm={async () => {
            await deleteStartup();
          }}
          onCancel={() => {
            setOpenSweetAlert(false);
          }}
        ></SweetAlert>
      )}

      {isSendMsg?.status && (
        <AddMessageModal isOpen={isSendMsg?.status} handleClose={() => setIsSendMsg({ data: isSendMsg?.data, status: false })} handleSubmit={(data) => sendMessageToAssignedUserForSelectedProject(data)} />
      )}
    </React.Fragment>
  );
}

export default withTranslation()(ProjectList)
